<template>
  <div style="max-height: 300px; overflow: scroll;">
    <!--ORDER-->
        <table style="min-width: 290px; max-width: 500px; max-height: 50px; overflow: auto;">
          <tr v-for="(item,key) in domainC.reverse()" >
            <td>
              <h3>
                <i v-if="!item.success" class="fa fa-paperclip">
                </i>
                <i v-else class="fa fa-anchor">
                </i>
              </h3>
            </td>
            <td style="min-width: 16px;">
            </td>
            <td>
              <h3>
                <i v-if="!item.success && item.available !=='false'">{{item.name}}</i>
                <i v-if="item.available==='false'">{{item.name}} <code>bereits registriert</code></i>
                <b-link v-else-if="item.success" @click="$router.push({name: 'domain-details-view', params: { name: item.name} })">{{item.name}}</b-link>
              </h3>
            </td>
            <td style="min-width: 16px;">
            </td>
            <td>
              <b-spinner v-if="item.spinner"></b-spinner>
            </td>
            <td>
              <div style="min-height: 30px;">
                <b-link><i class="fa fa-close" v-if="!item.spinner && !item.success"  @click="deleteSearchItem(item.name)"> </i></b-link>
                <h4 v-if="item.success" ><b-link @click="deleteSearchItem(item.name)" class="fa fa-check"></b-link>  <i>Bestellung Erfolgreich</i></h4>
              </div>
            </td>
          </tr>
        </table>
    <!--HANDLES-->
  </div>
</template>

<script>

  import {DomainSearchResult} from "@/store/models/layout/domain_search_result";

  export default {
    name:'luma-order-domain',
    computed:{
      domainC(){
        if(!DomainSearchResult.all()) return
        return DomainSearchResult.all()
      }
    },
    methods:{
      deleteSearchItem(index){
        DomainSearchResult.deleteSearchItem((index))
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/luma-order-domains.vue